import Session from './Session.js';
const PlaceHolder = (message, pupil = null) => {
    let msg = '' + message; //avoid reference. Immutability
    if (!pupil) pupil = Session.secureObject('pupil');
    const tags = ['#name', '# name', '#he\'s', '#she\'s', '#his', '#her', '#him', '#he', '#she'];
    let replace;
    if (pupil.gender === 'Male') {
        replace = [pupil.firstname, pupil.firstname, 'he\'s', 'he\'s', 'his', 'his', 'him', 'he', 'he'];
    } else {
        replace = [pupil.firstname, pupil.firstname, 'she\'s', 'she\'s', 'her', 'her', 'her', 'she', 'she'];
    }
    for (let i = 0; i < tags.length; i++) {
        msg = msg.split(tags[i]).join(replace[i]).split(tags[i].toUpperCase()).join(replace[i].toUpperCase()).split(titleCase(tags[i])).join(titleCaseReplace(replace[i]));
    }
    return msg;
};

const titleCase = (str) => {
    return str[0] + str[1].toUpperCase() + str.substring(2);
};
const titleCaseReplace = (str) => {
    return str[0].toUpperCase() + str.substring(1);
};
export default PlaceHolder;